import type { ReactNode } from 'react'

import './index.scss'

const sharedHeaderTemplate = ({
  className,
  color = '#626262',
  headerSubtitle,
  headerSubtitleClassname,
  headerTitle,
}: {
  className?: string
  color?: string
  headerSubtitle: string
  headerSubtitleClassname?: string
  headerTitle: string
}): ReactNode => {
  return `<div class="ag-cell-label-container ${className}" role="presentation">
            <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
            <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
            <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
              <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              <div class="column-header">
                ${headerTitle && `<div class="column-header__title">${headerTitle}</div>`}
                <div class="column-header__subtitle ${headerSubtitleClassname} ${
                  !headerSubtitle ? 'title-offset' : ''
                }" style="color: ${color};">${headerSubtitle}</div>
              </div>
              <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
              <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
              <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
              <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
              <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
            </div>
      </div>`
}

export default sharedHeaderTemplate
